var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51634 4.4572C8.57567 4.51653 8.57567 4.61245 8.51634 4.67178L4.43971 8.74841C4.36617 8.82195 4.26669 8.86316 4.1626 8.86316H1.28853C1.20469 8.86316 1.13684 8.79531 1.13684 8.71146V5.83704C1.13684 5.7333 1.17805 5.63348 1.25159 5.55994L5.32715 1.48437C5.38719 1.42433 5.48418 1.42433 5.54422 1.48437L8.63286 4.56414M0 5.47148V9.44473C0 9.75132 0.248683 10 0.555274 10H4.52852C4.69976 10 4.86389 9.93215 4.98503 9.811L9.83613 4.9599C10.0546 4.74141 10.0546 4.38757 9.83613 4.16909L5.83091 0.163865C5.61243 -0.0546215 5.25859 -0.0546215 5.0401 0.163865L0.188999 5.01497C0.067855 5.13611 0 5.30024 0 5.47148Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59516 5.59479C4.93899 5.59479 4.40503 5.06083 4.40503 4.40467C4.40503 3.7485 4.93899 3.21454 5.59516 3.21454C6.25133 3.21454 6.78528 3.7485 6.78528 4.40467C6.78528 5.06083 6.25133 5.59479 5.59516 5.59479ZM5.59516 3.99611C5.36992 3.99611 5.18661 4.17943 5.18661 4.40467C5.18661 4.6299 5.36992 4.81322 5.59516 4.81322C5.82039 4.81322 6.00371 4.6299 6.00371 4.40467C6.00371 4.17943 5.82039 3.99611 5.59516 3.99611Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/TagIcon.07f6a94dcb22aee18f152fc18e4bf5ad.svg";
export { ForwardRef as ReactComponent };